import { useClientTypeStore } from '@/store/clientTypes';
import { useClientsStore } from '@/store/clients';
import { useUsersStore } from '@/store/users';

export const clientsOptions = {
  getClientTypes: async (query: string | Record<string, any> = '') => {
    const store = useClientTypeStore();
    await store.fetchClientTypes(query);
    return store.client_types;
  },
  searchClientsAndLeads: async (query: string | Record<string, any> = '') => {
    const store = useClientsStore();
    await store.searchClientsAndLeads(query);// 'filter[tag]':'Agencia' });
    return store.clients_leads;
  },
  searchUsers: async (query: string | Record<string, any> = '') => {
    const store = useUsersStore();
    await store.searchUsers(query);
    return store.users_result;
  },
  searchAgencies: async (query: string | Record<string, any> = '') => {
    const store = useClientsStore();
    await store.searchClients(query);// 'filter[tag]':'Agencia' });
    return store.clients_result;
  },
};
